/**
 * Numeric codes attached to the `ServerError` thrown from `SusdleRoom.onAuth`
 * when a join is refused for a game-state reason (Epic 14-hardening Items
 * 10/11). Colyseus surfaces `ServerError.code` to the joining colyseus.js
 * client, where `classifyJoinError` maps it back to an `ErrorKind`. Single
 * source of truth for the server↔client contract so the two sides cannot
 * drift.
 *
 * Chosen at 44xx — outside Colyseus's entire reserved 4xxx span: the `Protocol`
 * WS-close band (WS_CLOSE_CONSENTED 4000, WS_CLOSE_WITH_ERROR 4002,
 * WS_CLOSE_DEVMODE_RESTART 4010, WS_SERVER_DISCONNECT 4201, WS_TOO_MANY_CLIENTS
 * 4202) and the matchmaking `ErrorCode` range (4210–4217). 4002 in particular
 * would have collided with WS_CLOSE_WITH_ERROR, making the client unable to tell
 * our rejection from a generic Colyseus error-close. (Verified against
 * @colyseus/core 0.16.24 Protocol.js.)
 *
 * Codes:
 *   - 4400 ROOM_FULL           — Epic 14-hardening Item 10 capacity gate
 *   - 4401 GAME_IN_PROGRESS    — Epic 14-hardening Item 11 mid-game-join gate
 *   - 4402 SCHEMA_MISMATCH     — Epic 15 schema-version handshake
 *   - 4403 DUPLICATE_ID        — codebase-audit 2.1 duplicate-player-id gate
 *     (client falls back to the generic 'join_error' classification — no
 *     bespoke UX; the only honest path to a duplicate id is a stale tab)
 */
export const JOIN_REJECT_CODE = {
    ROOM_FULL: 4400,
    GAME_IN_PROGRESS: 4401,
    SCHEMA_MISMATCH: 4402,
    DUPLICATE_ID: 4403,
};
//# sourceMappingURL=join-errors.js.map